import catalog from "./generated/catalog.json" with { type: "json" };
import type { CanonicalGame, CatalogData, Playability, SourceObservation } from "./types";

export { gatheringActivities, gatheringClosingCards, gatheringConversationCards, gatheringQuietResetCards } from "./gathering";
export type { GatheringActivity } from "./gathering";

export {
  alcoholOverdoseActions,
  alcoholOverdoseSigns,
  recoveryEvidenceLabels,
  recoveryFoods,
  recoveryMyths,
  recoveryPrinciples,
  recoverySourceById,
  recoverySources,
  recoverySupplements,
  recoveryTimeline,
} from "./recovery";
export type { RecoveryCard, RecoveryEvidenceLevel, RecoverySource } from "./recovery";

export type { BeginnerGuide, BeginnerGuideStep, BeginnerRound, CanonicalGame, CatalogData, CatalogNovelty, GameEnergy, GameMechanic, GameplayContract, GuideDiagramKind, ParticipationAccess, ParticipationAccessibility, Playability, RightsBoundary, RightsTreatment, SourceObservation, SourceRegion } from "./types";
export const catalogData = catalog as unknown as CatalogData;
export const games = catalogData.games;
export const observations = catalogData.observations;
export const restCards = catalogData.restCards;
export const promptPacks = catalogData.promptPacks;

const observationById = new Map(observations.map((observation) => [observation.observationId, observation]));

export function sourceCollectionCount(game: CanonicalGame): number {
  const sourceCodes = new Set<string>();
  for (const observationId of game.sourceObservationIds) {
    const observation = observationById.get(observationId);
    if (observation) sourceCodes.add(observation.sourceCode);
  }
  return sourceCodes.size;
}

const choseong = ["ㄱ","ㄲ","ㄴ","ㄷ","ㄸ","ㄹ","ㅁ","ㅂ","ㅃ","ㅅ","ㅆ","ㅇ","ㅈ","ㅉ","ㅊ","ㅋ","ㅌ","ㅍ","ㅎ"];
const initialJamo = ["ᄀ","ᄁ","ᄂ","ᄃ","ᄄ","ᄅ","ᄆ","ᄇ","ᄈ","ᄉ","ᄊ","ᄋ","ᄌ","ᄍ","ᄎ","ᄏ","ᄐ","ᄑ","ᄒ"];
export function initials(value: string): string {
  return [...value.normalize("NFKC")].map((char) => {
    const jamoIndex = initialJamo.indexOf(char);
    if (jamoIndex >= 0) return choseong[jamoIndex];
    const code = char.charCodeAt(0) - 0xac00;
    return code >= 0 && code <= 11171 ? choseong[Math.floor(code / 588)] : char.toLocaleLowerCase("ko-KR");
  }).join("");
}

export function normalizeSearch(value: string): string {
  return value.normalize("NFKC").toLocaleLowerCase("ko-KR").replace(/[\s\p{P}\p{S}]+/gu, "");
}

export function searchGames(query: string, list: CanonicalGame[] = games): CanonicalGame[] {
  const normalized = normalizeSearch(query);
  if (!normalized) return list;
  const initialQuery = initials(normalized);
  return list.filter((game) => [game.displayName, ...game.aliases, ...game.searchAliases, game.canonicalId].some((candidate) => {
    const value = normalizeSearch(candidate);
    return value.includes(normalized) || initials(value).includes(initialQuery);
  }));
}

export { sameMindContent, sameMindPrompts, unusedSameMindPrompts } from "./sameMind";
export type { SameMindPrompt } from "./sameMind";
